import React from 'react';

function About(props:any
) {
  return (
      <div>About</div>
  );
}

export default About;